module.exports = __webpack_public_path__ + "img/fancy-list-2.9540941.png";